var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "place",
        "min-height": 500,
        adaptive: true,
        scrollable: true,
        width: "925",
        height: "auto"
      },
      on: { closed: _vm.handleClose }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "guide-modal p-0 md:px-10 md:py-20" }, [
          _c(
            "button",
            {
              staticClass: "modal-exit--grey",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$modal.hide("place")
                }
              }
            },
            [_c("div", { staticClass: "fal fa-times h3" })]
          ),
          _c(
            "div",
            {
              staticClass:
                "max-h-modal-mobile overflow-auto mt-32 xl:mt-0 md:max-h-modal xl:max-h-full"
            },
            [
              _vm.place.id
                ? _c("div", { staticClass: "p-8 md:px-24" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "title--md text-center font-bold mb-8 md:mt-0 md:pt-0"
                      },
                      [_vm._v(_vm._s(_vm.place.attributes.title))]
                    ),
                    _vm.place.attributes.pictures.length
                      ? _c(
                          "div",
                          { staticClass: "slider-detail" },
                          [
                            _c(
                              "agile",
                              {
                                attrs: {
                                  autoplay: true,
                                  speed: 750,
                                  timing: "ease-in-out",
                                  dots: false,
                                  "nav-buttons": false,
                                  "pause-on-hover": false,
                                  "slides-to-show": 1,
                                  "autoplay-speed": 8000,
                                  responsive: [
                                    {
                                      breakpoint: 992,
                                      settings: {
                                        navButtons: true,
                                        dots: true,
                                        centerMode: true
                                      }
                                    }
                                  ]
                                }
                              },
                              [
                                _vm._l(_vm.place.attributes.pictures, function(
                                  picture
                                ) {
                                  return _c("div", { staticClass: "slide" }, [
                                    _c("img", { attrs: { src: picture } })
                                  ])
                                }),
                                _c("template", { slot: "prevButton" }, [
                                  _c("i", {
                                    staticClass: "fal fa-chevron-left"
                                  })
                                ]),
                                _c("template", { slot: "nextButton" }, [
                                  _c("i", {
                                    staticClass: "fal fa-chevron-right"
                                  })
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "h4 font-medium text-center my-6 mx-20 p-2 leading-15 md:p-0 md:mx-0 md:mb-8 md:text-left lg:mt-0"
                      },
                      [_vm._v(_vm._s(_vm.place.attributes.address))]
                    ),
                    _c(
                      "div",
                      { staticClass: "block mb-16 md:flex md:justify-between" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "block md:flex md:content-start md:justify-start"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-secondary h5 p-0 m-0 text-center md:text-left md:pr-6 md:mt-1"
                              },
                              [_c("i", { staticClass: "fas fa-bus" })]
                            ),
                            _c("div", {
                              staticClass:
                                "h5 font-medium leading-15 text-center md:text-left",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.place.attributes.access_html
                                )
                              }
                            })
                          ]
                        ),
                        _vm.place.attributes.opening_description
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "block md:flex md:content-start md:justify-start"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-secondary h5 p-0 m-0 text-center md:text-left md:pr-6 md:mt-1"
                                  },
                                  [_c("i", { staticClass: "fas fa-clock" })]
                                ),
                                _c("div", {
                                  staticClass:
                                    "h5 font-medium leading-15 text-center md:text-left",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.place.attributes
                                        .opening_description_html
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-title leading-15 h2 mb-6 text-secondary text-center text-3xl md:text-4xl md:text-left"
                      },
                      [_vm._v(_vm._s(_vm.place.attributes.description_title))]
                    ),
                    _c("div", { staticClass: "wysiwyg-wrapper" }, [
                      _c("p", {
                        staticClass: "h4 font-medium mb-16",
                        domProps: {
                          innerHTML: _vm._s(_vm.place.attributes.description)
                        }
                      })
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "flex justify-center mb-4 md:justify-start"
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "btn btn-secondary mr-8 text-center flex items-center",
                            attrs: { href: "tel:" + _vm.place.attributes.phone }
                          },
                          [_vm._v(_vm._s(_vm.place.attributes.phone))]
                        ),
                        _vm.place.attributes.website_without_scheme
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-outline-secondary-whitebg border-2 w-full md:w-auto text-center",
                                attrs: {
                                  href: _vm.place.attributes.website,
                                  target: "_blank",
                                  rel: "noopener"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.place.attributes.website_without_scheme
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                : _vm._e()
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }